export {default as SendCommentaire} from "./send-commentaire"
export {default as ViewCommentaires} from "./view-commentaires"
export {default as CommentairesWrapper} from "./commentaire-wrapper"